// src/data/catalog.js
export const catalog = [
  // SERVICES
  { kind: "service", title: "Modeling", description: `
 We craft high quality 3D models that blend creativity with precision perfect for films, games, products, AR/VR, and architectural visualization.

Our 3D Modeling Services:

1. Characters & Creatures Modeling:
   Bring heroes, creatures and stylized figures to life with detailed sculpting and optimized topology.

2. Products Modeling:
   High quality or low poly 3D models for advertisements, AR/VR, animations and e commerce.

3. Environments & Props:
   From small detailed assets to full immersive worlds crafted with realism.

4. Architecture Modeling:
   Interior, exterior and furniture modeling for visualization and real estate presentation.

5. Stylized & Concept Models:
   Artistic, stylized, and experimental designs to explore unique visual directions.

Industries We Serve:
- Animation & Film Studios  
- Gaming Companies  
- Advertising & Branding Agencies  
- AR/VR Production  
- Architecture & Real Estate  
- Product Design & E commerce.`, 
    image: '/images/modeling.webp', 
    features: ["Low poly & high poly", "Character modeling", "Product modeling"], 
    gallery: ["/images/modeling1.webp", "/images/modeling2.webp"] 
  },

  { kind: "service", title: "Texture", description: `
 Turn plain 3D models into stunning, realistic visuals with perfect detail.

Our Texturing Expertise:

🎨 Realistic Materials  
From skin to steel textures crafted to feel lifelike.

🎨 Stylized Looks  
Hand painted and artistic textures for unique visual styles.

🎨 PBR Workflows  
Game ready and film ready PBR textures with accurate maps.

🎨 Custom Finishes  
Tailored material details to match your project’s look and mood.
`,
    image: "/images/texture.webp", 
    features: ["Tileable maps", "PBR sets"], 
    gallery: ["/images/texture1.webp","/images/texture2.webp"] 
  },

  { kind: "service", title: "Lighting", description: ` Good lighting transforms a scene from ordinary to unforgettable.
 
Our Lighting Expertise:
 
💡 Cinematic Lighting
Film style moods that capture emotions.
 
💡 Product Lighting
Highlight every curve & detail with precision.
 
💡 Environment Lighting
Day, night, or fantasy we set the atmosphere.
 
💡 Stylized & Creative
Artistic lighting that adds, drama & style.`, 
    image:"/images/light.webm",
    features: ["HDRI setups", "Studio lighting"], 
    gallery: ["/images/lighting1.webp","/images/lighting2.webp"] 
  },

  { kind: "service", title: "Rigging", description: ` The hidden framework that makes characters and objects move naturally.
 
Our Rigging Expertise:
 
🎭 Character Rigging
Realistic body mechanics & facial expressions.
 
🤖 Creature Rigging
From animals to monsters smooth, believable movement.
 
⚙️ Mechanical Rigging
Machines, vehicles & props with precise controls.
 
🎮 Game & Animation Ready
Optimized rigs for seamless performance in any pipeline.`, 
    image: "/images/rig.webp", 
    features: ["Character rigs", "Animation ready"], 
    gallery: ["/images/rig1.webp","/images/rig3.webp"] 
  },

  { kind: "service", title: "Animation", description: ` From subtle expressions to epic action we bring 3D models to life.
 
Our Animation Expertise:
 
🎬 Character Animation
Expressive performances with emotions & personality.
 
🕹️ Game Animation
Smooth, responsive moves for gameplay & cutscenes.
 
🐾 Creature Animation
Natural motion for animals, fantasy beings & monsters.
 
📢 Product & Explainer Animation
Showcase ideas, products & stories in engaging motion.`, 
    image: "/images/animation1.webm", 
    features: ["Character animation", "Product animation"], 
    gallery: ["/images/animation2.webm","/images/animation3.webm"] 
  },

  { kind: "service", title: "Rendering", description: ` Transform 3D scenes into stunning, photorealistic visuals.
 
Our Rendering Expertise:
 
📸 Photoreal Rendering
Ultra detailed, lifelike images that feel real.
 
🎥 Animation Rendering
High quality frames for films, ads & games.
 
🏙️ Architectural Visualization
Realistic interiors, exteriors & walkthroughs.
 
🛍️ Product Rendering
Showcase products with cinematic style & precision.`, 
    image: "/images/rendering.webp", 
    features: ["Cycles & Eevee", "V-Ray & Arnold"], 
    gallery: ["/images/rendering1.webp","/images/rendering2.webp"] 
  },

  { kind: "service", title: "Poster & Banner", description: ` Bold, creative designs that grab attention instantly.
What We Create:
🖼️ Posters
Striking layouts for events, films, brands & promotions.
📢 Banners
Clean, impactful designs for websites, ads & social media.
🎨 Custom Graphics
Unique visuals tailored to your theme & message.
📱 Social Media Creatives
Engaging designs optimized for Instagram, YouTube & more.`, 
    image: "/images/banner4.webp", 
    features: ["Social media banners", "Event posters"], 
    gallery: ["/images/banner1.webp","/images/banner3.webp"] 
  },

  { kind: "service", title: "CGI Ads", description: ` Eye catching visuals that stop the scroll and boost engagement.
What We Create:
📢 Product CGI Ads
Show every feature with dramatic, cinematic visuals.
⚡ Motion Graphics & VFX Ads
Dynamic effects that grab instant attention.
🛍️ E commerce & Social Media Ads
High converting visuals for Instagram, YouTube & brand campaigns.
🎥 Story Based CGI Commercials
Short, impactful narratives that connect with viewers.`, 
    image: "/images/cgi.webm", 
    features: ["Product CGI", "Advertisement visuals"], 
    gallery: ["/images/cgi1.webp","/images/cgi2.webp"] 
  },

  { kind: "service", title: "AI Design", description: ` Where artificial intelligence supercharges the world of 3D.
 
Our Expertise:
 
🎨 Designer Side (AI Assisted)
Uses AI tools to generate 3D assets, textures & animations
Creates style variations & concepts faster with AI driven design
Enhances creativity with generative workflows instead of starting from scratch`, 
    image: "/images/ai5.webm", 
    features: ["AI concept art", "AI image/video"], 
    gallery: ["/images/ai1.webm","/images/ai4.webm"] 
  },
  { 
  kind: "service", 
  title: "UI & UX Design", 
  description: ` Create clean, modern, and user-friendly interface designs for web and mobile applications. Every design is crafted with a focus on visual consistency, intuitive layouts, and a seamless handoff for development.
 
Our Expertise
 
💡 User Research
Understand user needs and project requirements.
 
🎨 Wireframing & UI Design
Create intuitive layouts and visually engaging interfaces.
 
📱 Web & Mobile UI Design
Design responsive interfaces for web and mobile platforms.
 
🎯 Design Systems
Maintain consistent colors, typography, and reusable UI components.`, 
  image:"/images/ui_ux_1.webp", 
  features: ["Pixel-Perfect UI Design", "Responsive Web & Mobile Layouts"], 
  gallery: ["/images/ui_ux_4.webp", "/images/ui_ux_5.webp", "/images/ui_ux_7.webp", "/images/ui_ux_6.webp","/images/ui_ux_8.webp","/images/ui_ux_10.webp"] 
},


  // COURSES
  {
    kind: "course",
    title: "Graphic Design Basics",
    subtitle: "Photoshop, Illustrator, CorelDraw",
    duration: "3 Month",
    fees: "₹800–₹1,200/hour",
    description: " Learn the fundamentals of visual design, creating attractive logos, posters, and brand graphics.",
    image: "/images/course-graphic.webp",
    features: ["Photoshop Basics", "Logo Creation", "Poster & Social Media Design"]
  },
  {
    kind: "course",
    title: "3D Modeling & Texturing Specialist",
    subtitle: "Maya, Blender, Substance Painter, Photoshop",
    duration: "5 Months",
    fees: "₹800–₹1,200/hour",
    description: " Learn to create detailed 3D models and enhance them with professional, realistic textures.",
    image: "/images/course-lighting.webp",
    features: ["Character and Props Modeling","High Poly & Low Poly Models","PBR Texturing","UV Mapping"]
  },
  {
    kind: "course",
    title: "Lighting & Render",
    subtitle: "Arnold, Blender, V ray, Unreal engine",
    duration: "3 Month",
    fees: "₹800–₹1,200/hour",
    description: " Master cinematic lighting and produce high quality final renders for films, ads, and animation.",
    image: "/images/course-envlight.webp",
    features: ["Studio Lighting", "Product Lighting", "Cinematic Lighting"],
  },
  {
    kind: "course",
    title: "3D Animation Fundamentals & Rigging",
    subtitle: "Maya, Blender",
    duration: "4 Month",
    fees: "₹800–₹1,200/hour",
    description: " Understand animation principles and build characters ready for smooth, expressive movement.",
    image: "/images/course-render.webp",
    features: ["Character & Props Animation","Character & Props Rigging"],
  },
  {
    kind: "course",
    title: "Personal 1-to-1 Custom Mentorship",
    subtitle: "Any Software",
    duration: "Flexible",
    fees: "₹800–₹1,200/hour",
    description: " Fully personalized learning sessions tailored to your goals, pace, and preferred workflows.",
    image: "/images/course-mentor.webp",
    features: ["Custom Syllabus", "Skill Based Coaching"]
  },
  {
    kind: "course",
    title: "Kids & Teen Design Starter",
    subtitle: "Art, Concept & Basic 3D",
    duration: "Flexible",
    fees: "₹800–₹1,200/hour",
    description: " A fun and simple introduction to creativity, art, and basic 3D concepts for young learners.",
    image: "/images/course-kids.webp",
    features: ["Basic Art", "Intro to 3D"]
  }
];
